import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [
    
  ]
})
export class AppComponent implements OnInit {
  title = 'frontend';

  constructor(private primengConfig: PrimeNGConfig, private translateService: TranslateService) { }

  ngOnInit() {
      this.primengConfig.ripple = true;

      this.primengConfig.setTranslation({
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        monthNamesShort: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez"
        ],
    });


      this.translateService.setDefaultLang('pt-br');
      this.translateService.use('pt-br');

      // @ts-ignore
      window.clarity("identify", localStorage.getItem("emailUsuario"), "", "")
  }
}
